"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _data = _interopRequireDefault(require("../data.json"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

/**
 * Tests whether a string is a valid subdomain or not.
 * Will also check whether it is a reserved subdomain.
 * @param {sstring} name - the subdomain name to check
 * @return {boolean} whether it is valid
 */
function _default(name) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var regexResult = /^[\w](?:[\w-]{0,61}[\w])?$/.test(name);
  /* deprecations */

  if (opts.blacklist) {
    console.log('namor: "blacklist" option is now deprecated, use "reserved" instead');
    opts.reserved = opts.blacklist;
  }
  return opts.reserved ? regexResult && _data["default"].reserved.indexOf(name) === -1 : regexResult;
}